module.exports = __webpack_public_path__ + "static/media/icon-nosignal.a2a987a5.png";